// extracted by mini-css-extract-plugin
module.exports = {"form":"EAFConserveRecord_form__3bZK2","content":"EAFConserveRecord_content__msIsC","contentMain":"EAFConserveRecord_contentMain__39W39","select":"EAFConserveRecord_select__2N5ML"};